import { render, staticRenderFns } from "./FaceCardForTest.vue?vue&type=template&id=45940dec&scoped=true&"
import script from "./FaceCardForTest.vue?vue&type=script&lang=js&"
export * from "./FaceCardForTest.vue?vue&type=script&lang=js&"
import style0 from "./FaceCardForTest.vue?vue&type=style&index=0&id=45940dec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45940dec",
  null
  
)

export default component.exports